/**
 * Format a date as relative time in English (e.g., "3 days ago")
 */
export const timeAgo = (dateString) => {
  if (!dateString) return "";

  const seconds = Math.floor((Date.now() - new Date(dateString).getTime()) / 1000);
  if (seconds < 60) return "just now";

  const units = [
    [31536000, "year", "years"],
    [2592000, "month", "months"],
    [604800, "week", "weeks"],
    [86400, "day", "days"],
    [3600, "hour", "hours"],
    [60, "minute", "minutes"],
  ];

  for (const [secs, singular, plural] of units) {
    const count = Math.floor(seconds / secs);
    if (count >= 1) return `${count} ${count === 1 ? singular : plural} ago`;
  }
  return "just now";
};

/**
 * Format view count (1234 -> "1.2K", 1500000 -> "1.5M")
 */
export const formatCount = (n) => {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return String(n);
};
